import fallbackImg from "../../assets/user.png"; // Import the fallback image
import { formatDistanceToNow } from 'date-fns';

// Function to format Firestore timestamp to "time ago" format
export const formatDate = (timestamp) => {
  const date = timestamp.toDate(); // Convert Firestore Timestamp to JavaScript Date object
  return formatDistanceToNow(date, { addSuffix: true }); // Format date to "time ago" format
};


export const userColumns = [
  {
    field: "id",
    headerName: "ID",
    width: 200,
  },
  
  {
    field: "availableSlots",
    headerName: "Slots",
    width: 80,
  },
  {
    field: "date",
    headerName: "Date",
    width: 200,
  },
  {
    field: "firstslottime",
    headerName: "First Half",
    width: 150,
  },
  {
    field: "secondsslottime",
    headerName: "Second Half",
    width: 150,
  },
  {
    field: "note",
    headerName: "Note",
    width: 100,
  },
  {
    field: "timestamp",
    headerName: "Timestamp",
    width: 150,
    valueGetter: (params) => formatDate(params.value), // Use valueGetter to format createdAt field
  },
  {
    field: "status",
    headerName: "Status",
    width: 100,
    renderCell: (params) => {
      return (
        <div className={`cellWithStatus ${params.row.status}`}>
          {params.row.status}
        </div>
      );
    },
  },
];
